import { Input } from 'reactstrap'

export default function SearchFormYesNo(props) {
  const { index, onChangeFunction, defaultValue } = props
  console.log('SearchFormYesNo rendered: ', props)

  return (
    <Input index={index} type="select" name="inputValue" bsSize="sm" data-cy="search-form-yes-no" className="search-form-yes-no" onChange={onChangeFunction} defaultValue={defaultValue} >
      <option key={0} value=""></option>
      <option key={1} value="N">No</option>
      <option key={2} value="Y">Yes</option>
    </Input>
  )
}